const maxMessageLength = 1000;

function formatConsoleArguments(args: any[]): string {
	return args
		.map((arg) => {
			let str = '';
			if (typeof arg === 'object' && arg !== null) {
				try {
					str = JSON.stringify(arg, null, 2);
				} catch (e) {
					str = String(arg);
				}
			} else if (typeof arg === 'string') {
				str = arg;
			} else {
				str = String(arg);
			}

			// Обрезаем сообщение, иначе есть шанс, что рейдж вылетит (-_-' )
			if (str.length > maxMessageLength) {
				return (
					str.slice(0, maxMessageLength) +
					`...\n(showing ${maxMessageLength} of ${str.length} characters)`
				);
			} else {
				return str;
			}
		})
		.join(' ');
}

export function setupRageConsoleHooks() {
	const originalConsole = {
		log: console.log,
		info: console.info,
		warn: console.warn,
		error: console.error,
	};

	function hookConsoleFunction(type: 'log' | 'info' | 'warn' | 'error') {
		console[type] = function (...args: any[]) {
			originalConsole[type].apply(console, args);
			const formattedMessage = formatConsoleArguments(args);
			mp.trigger('gui:log', type, formattedMessage);
		};
	}

	hookConsoleFunction('log');
	hookConsoleFunction('info');
	hookConsoleFunction('warn');
	hookConsoleFunction('error');
}
